module.exports = __webpack_public_path__ + "img/16.a6a7c856.jpg";